import * as SPINNER from "../helpers/spinner";
import DataLayerEvent from "../gtm/DataLayerEvent";

// add a product to the cart
window.addToCart = function (
    image_url,
    original_image_url,
    product,
    quantity,
    price
) {
    SPINNER.showSpinner();
    axios
        .post("/ajax/cart/add/" + product.id, {
            product: product,
            quantity: quantity,
        })
        .then(function (response) {
            if (response.data) {
                const dataLayerEvent = new DataLayerEvent();
                dataLayerEvent.addEvent(
                    "add_to_cart",
                    product,
                    quantity,
                    price
                );
                $(".main__image").attr("srcset", image_url);
                $(".original__image").attr("srcset", original_image_url);
                $(".product__image").attr("src", image_url);
                $(".product__title").html(product.name);
                $(".product__quantity").html(quantity + "x");
                $(".product__price").html(price);
                addOptionsToModal(response.data.selection);
                $("#shopping-cart-modal").modal("show");
                getCartProductsCount();
                SPINNER.hideSpinner();
            }
        })
        .catch(function (error) {
            if (error && error.response && error.response.status === 419) {
                window.refreshCsrfToken().then(() => {
                    window.addToCart(
                        image_url,
                        original_image_url,
                        product,
                        quantity,
                        price
                    );
                });
            } else {
                axios
                    .post("/ajax/error", {
                        message: error,
                    })
                    .then(function (response) {
                        let message = "Er is iets misgegaan." + "\n\n";
                        message += "Object fout:" + error.name + "\n";
                        message += "Foutmeldingscode:" + error.code + "\n";
                        message += error.message + "\n\n";
                        message +=
                            "Probeer het opnieuw of neem contact op met de klantenservice.\n";
                        alert(message);
                    });
            }
        });
};

(window.refreshCsrfToken = function () {
    return axios.get("/no-cache/csrf", function (data) {
        $('meta[name="csrf-token"]').attr("content", data);
        axios.defaults.headers.common["X-CSRF-TOKEN"] = data;
    });
}),
    (window.addOptionsToModal = function (selection) {
        $(".product__selections").hide();
        $(".product__options").empty();
        if (selection.checkbox_options) {
            $(".product__selections").show();
            for (let key in selection.checkbox_options) {
                let option = selection.checkbox_options[key];
                if (option.name == "Helium") {
                    $(".product__options").append(
                        "<div> Gevuld met helium (incl. lintje en gewichtje) </div>"
                    );
                } else {
                    $(".product__options").append(
                        "<div>" + option.name + "</div>"
                    );
                }
            }
        }
    });

window.getCartProductsCount = function () {
    if (!$(".header-cart").hasClass("show")) {
        axios
            .get("/ajax/cart/content-count")
            .then(function (response) {
                setCartCounter(response.data);
            })
            .catch(function () {
                setCartCounter();
            });
    }
};

window.setCartCounter = function (count = 0) {
    if ($(".product-counter").length > 0) {
        let counters = $(".product-counter");
        if (count > 0) {
            $(counters).css("display", "flex");
            $(counters).css("visibility", "visible");
            $(counters).text(count);
        } else {
            $(counters).css("visibility", "hidden");
        }
    }
};
// fill the cart in the header
const headercart = new Vue({
    el: "#header-cart",
    data: {
        header_cart: {},
    },
    mounted: function () {
        $("#menu-cart").on("click", this._getCartData);
    },
    methods: {
        _getCartData: function () {
            SPINNER.showHeaderSpinner();
            if (!$(".header-cart").hasClass("show")) {
                const vm = this;
                axios
                    .get("/ajax/cart/content")
                    .then(function (response) {
                        vm.header_cart = response.data;
                        SPINNER.hideHeaderSpinner();
                    })
                    .catch(function (error) {
                        SPINNER.hideHeaderSpinner();
                        axios
                            .post("/ajax/error", {
                                message: error,
                            })
                            .then(function (response) {
                                let message = "Er is iets misgegaan." + "\n\n";
                                message += "Object fout:" + error.name + "\n";
                                message +=
                                    "Foutmeldingscode:" + error.code + "\n";
                                message += error.message + "\n\n";
                                message +=
                                    "Probeer het opnieuw of neem contact op met de klantenservice.\n";
                                alert(message);
                            });
                    });
            }
        },
        currency: function (value) {
            return (
                "€ " +
                parseFloat(value)
                    .toFixed(2)
                    .replace(".", ",")
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            );
        },
    },
});
